<div class="image-avatar-wrapper">
  <div class="image-inner-container">
    <img
      [src]="profilePictureUrl()"
      width="40"
      height="40"
      [attr.alt]="name() + ' profile'"
      loading="lazy" />

    <div class="image-actions">
      <input
        name="uploadFile"
        type="file"
        (change)="onFileSelected($event)"
        accept="image/*"
        class="visually-hidden"
        #fileInput />

      <mat-menu #profilePictureMenu>
        <button mat-menu-item (click)="fileInput.click()">
          <mat-icon>cloud_upload</mat-icon>
          {{ 'Contacts.Management.ProfilePicture.Upload' | translate: locale.language }}
        </button>
        <button mat-menu-item (click)="onDeleteImage()">
          <mat-icon>delete</mat-icon>
          {{ 'Contacts.Management.ProfilePicture.Remove' | translate: locale.language }}
        </button>
      </mat-menu>

      @if (hasProfilePicture()) {
        <button
          mat-icon-button
          type="button"
          [matMenuTriggerFor]="profilePictureMenu"
          class="image-upload-button"
          [attr.aria-label]="'Contacts.Management.ProfilePicture.EditAriaLabel' | translate: locale.language">
          <mat-icon>edit</mat-icon>
        </button>
      } @else {
        <button
          mat-icon-button
          type="button"
          (click)="fileInput.click()"
          class="image-upload-button"
          [attr.aria-label]="'Contacts.Management.ProfilePicture.UploadAriaLabel' | translate: locale.language">
          <mat-icon>cloud_upload</mat-icon>
        </button>
      }
    </div>
  </div>
  <span class="image-edit-badge">
    <mat-icon>camera_alt</mat-icon>
  </span>
</div>
